module.exports = __webpack_public_path__ + "img/values-service.8f0c0b52.gif";